// extracted by mini-css-extract-plugin
module.exports = {"row":"Layout_row__32EVB","fill":"Layout_fill__1P7JY","mainColumnSize":"Layout_mainColumnSize__13zSz"};